import React, { useEffect, useState, useCallback } from 'react'
import clsx from 'clsx'
import { Link } from 'react-router-dom'
import useGameStore from '../../../../../hooks/useGameStore'
import { observer } from 'mobx-react'
import { PickComment, commentDefaultData, commentPlaceholder } from '../../pickComment'
import useStore from '../../../../../hooks/useStore'
import { timeUtils } from '../../../../../common/utils/timeUtil'
import useModalStore from '../../../../../hooks/useModalStore'
import CreatableSelect from 'react-select/creatable'
import { getPickTypeDoubleDragon } from './helpers'

let todayDate = timeUtils.dateFormatYmd(timeUtils.todayYmd())

const DoubleDragonPick = observer(({ brandName, gameName }) => {
  const [tab, setTab] = useState('dist')
  const [option, setOption] = useState('all')
  const gameStore = useGameStore()
  const { clockStore } = useStore()
  const [currentRound, setCurrentRound] = useState(0)
  const [currentLatestRound, setCurrentLatestRound] = useState(0)
  const [pickClass, setPickClass] = useState('runningball_odd')
  const [pickComment, setPickComment] = useState()
  const modalStore = useModalStore()
  const [pick, setPick] = useState('odd')
  const [pickType, setPickType] = useState('')
  const [commentIndex, setCommentIndex] = useState(commentDefaultData[0])

  const getGameTypeParameter = useCallback(() => {
    switch (gameName) {
      case 'space8':
        return 'space8'
      case 'runningball5_6':
        return 'running_ball6'
      case 'runningball5_4':
        return 'running_ball4'
      case 'runningball3':
        return 'running_ball2'
      case 'double_dragon':
        return 'double_dragon'
    }
  })

  useEffect(() => {
    let interval = null
    if (currentRound !== 0) {
      interval = setInterval(() => {
        clockStore.getDoubleDragonRound().then((res) => {
          setCurrentLatestRound(res.nextRound)
        })
        gameStore.getLotteryPickList({
          gameType: getGameTypeParameter(),
          pickType: option === 'all' ? null : option,
          limit: 10,
          offset: 0,
          date: timeUtils.dateFormatYmd(todayDate),
          round: currentRound,
        })
      }, 1500)

      gameStore.getLotteryPickCommentList({
        gameType: getGameTypeParameter(),
        pickType: getPickTypeDoubleDragon(option),
        limit: 10,
        offset: 0,
        concat: false,
        date: timeUtils.dateFormatYmd(todayDate),
        round: currentRound,
      })
    }
    return () => {
      clearInterval(interval)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tab, option, currentRound])

  useEffect(() => {
    clockStore.getDoubleDragonRound().then((res) => {
      setCurrentRound(res.currentRound)
      setCurrentLatestRound(res.currentRound)
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getRoundDate = () => {
    return timeUtils.dateFormatCalendarYmd(todayDate) + ' - ' + currentRound
  }

  const onClickPreRound = () => {
    if (currentRound === 1) {
      todayDate = timeUtils.dateFormatCalendarYmd(timeUtils.datePrevOrNext(todayDate, 'prev'))
      setCurrentRound(660)
    } else {
      setCurrentRound(currentRound - 1)
    }
  }

  const onClickNextRound = () => {
    clockStore.getDoubleDragonRound().then((res) => {
      if (todayDate === timeUtils.dateFormatCalendarYmd(timeUtils.todayYmd()) && currentRound === res.currentRound) {
        return
      } else {
        if (currentRound === 660) {
          todayDate = timeUtils.dateFormatCalendarYmd(timeUtils.datePrevOrNext(todayDate, 'next'))
          setCurrentRound(1)
        } else {
          setCurrentRound(currentRound + 1)
        }
      }
    })
  }

  const runningballSectionDisplay = (index) => {
    if (index !== option && option !== 'all') {
      return 'none'
    }
  }

  const onSetPickComment = (e) => {
    if (!e) {
      setCommentIndex()
      setPickComment()
      return
    }
    if (e.__isNew__) {
      e.index = 999
    }
    setCommentIndex(e)
    setPickComment(e.value)
  }

  const insertPickComment = () => {
    if (commentIndex === null || commentIndex.index === 0) {
      modalStore.openAlertModal({
        message: '픽 메세지를 선택해 주세요',
      })
      return
    }

    gameStore
      .insertLotteryPickComment({
        gameType: getGameTypeParameter(),
        pickType: pickType,
        pick: pick,
        pickComment: pickComment,
      })
      .then(() => {
        if (gameStore.code === 200) {
          setCommentIndex(null)
          setPickComment(null)
        }
      })
  }

  const onSetPick = (pickClass, pickType, pick) => {
    setPickClass(pickClass)
    setPick(pick)
    setPickType(pickType)
  }
  return (
    <div className='game_stats_area'>
      {/* option_area */}
      <div className='option_tab'>
        <ul>
          <li>
            <a onClick={() => setTab('dist')} className={clsx('item', tab === 'dist' && 'selected')}>
              픽분포도
            </a>
          </li>
          <li>
            <a onClick={() => setTab('reg')} className={clsx('item', tab === 'reg' && 'selected')}>
              픽등록
            </a>
          </li>
        </ul>
      </div>
      {tab === 'dist' && (
        <>
          <div className='option_area'>
            <div className='date_area'>
              <Link className='btn_prev' onClick={() => onClickPreRound()} to={`${location.pathname}?tab=pick`}>
                이전 날짜
              </Link>
              <strong className='date'>{getRoundDate()}</strong>
              {currentRound < currentLatestRound && (
                <Link className='btn_next' onClick={() => onClickNextRound()} to={`${location.pathname}?tab=pick`}>
                  다음 날짜
                </Link>
              )}
            </div>
            <div className='option_type'>
              <select value={option} onChange={(e) => setOption(e.target.value)}>
                <option value='all'>전체</option>
                <option value='ball_1_odd_even'>1번볼 (빨간색)</option>
                <option value='ball_2_odd_even'>2번볼 (노란색)</option>
              </select>
            </div>
          </div>
          {/* // option_area */}

          {/* date_detail_wrap */}
          <div className='date_detail_wrap'>
            {/* data_summary */}
            <div className='data_summary'>
              <h3 className='tit'>전체 픽 분포도</h3>
              <div
                className='chart'
                style={{
                  display: runningballSectionDisplay('ball_1_odd_even'),
                }}
              >
                <dl className={clsx('bar ODD', gameStore.data.dist.ball_1_odd_percent > '50' && 'on')}>
                  <dt>1번볼 (빨간색) 홀</dt>
                  <dd>
                    <span className='num'>{gameStore.data.dist.ball_1_odd_count}</span>
                    <span className='per'>({gameStore.data.dist.ball_1_odd_percent}%)</span>
                  </dd>
                </dl>
                <dl className={clsx('bar EVEN', gameStore.data.dist.ball_1_even_percent > '50' && 'on')}>
                  <dt>1번볼 (빨간색) 짝</dt>
                  <dd>
                    <span className='num'>{gameStore.data.dist.ball_1_even_count}</span>
                    <span className='per'>({gameStore.data.dist.ball_1_even_percent}%)</span>
                  </dd>
                </dl>
              </div>
              <div
                className='chart'
                style={{
                  display: runningballSectionDisplay('ball_2_odd_even'),
                }}
              >
                <dl className={clsx('bar ODD', gameStore.data.dist.ball_2_odd_percent > '50' && 'on')}>
                  <dt>2번볼 (노란색) 홀</dt>
                  <dd>
                    <span className='num'>{gameStore.data.dist.ball_2_odd_count}</span>
                    <span className='per'>({gameStore.data.dist.ball_2_odd_percent}%)</span>
                  </dd>
                </dl>
                <dl className={clsx('bar EVEN', gameStore.data.dist.ball_2_even_percent > '50' && 'on')}>
                  <dt>2번볼 (노란색) 짝</dt>
                  <dd>
                    <span className='num'>{gameStore.data.dist.ball_2_even_count}</span>
                    <span className='per'>({gameStore.data.dist.ball_2_even_percent}%)</span>
                  </dd>
                </dl>
              </div>
            </div>
            {/* // data_summary */}

            {/* pick_list_wrap */}
            <div className='pick_list_wrap'>
              <h3 className='tit'>유저의 픽</h3>
              <div className='pick_list'>
                <PickComment
                  gameType={getGameTypeParameter()}
                  pickType={option}
                  items={gameStore.data.comment.list}
                  totalCnt={gameStore.data.comment.total_cnt}
                  date={timeUtils.dateFormatYmd(todayDate)}
                  round={currentRound}
                />
              </div>
            </div>
            {/* // pick_list_wrap */}
          </div>
          {/* // date_detail_wrap */}
        </>
      )}
      {tab === 'reg' && (
        <>
          {/* pick_register_wrap */}
          <div className='pick_register_wrap'>
            {/* pick_select */}
            <div className='pick_select'>
              <h3 className='tit'>픽 선택</h3>
              <div className='item'>
                <button
                  type='button'
                  className={clsx('ODD', pickClass === 'ball_1_odd' && 'selected')}
                  onClick={() => onSetPick('ball_1_odd', 'ball_1_odd_even', 'odd')}
                >
                  <span className='tx'>1번볼 (빨간색) 홀</span>
                  <span className='per'>{gameStore.data.dist.ball_1_odd_percent}%</span>
                </button>
                <button
                  type='button'
                  className={clsx('EVEN', pickClass === 'ball_1_even' && 'selected')}
                  onClick={() => onSetPick('ball_1_even', 'ball_1_odd_even', 'even')}
                >
                  <span className='tx'>1번볼 (빨간색) 짝</span>
                  <span className='per'>{gameStore.data.dist.ball_1_even_percent}%</span>
                </button>
              </div>

              <div className='item'>
                <button
                  type='button'
                  className={clsx('ODD', pickClass === 'ball_2l_odd' && 'selected')}
                  onClick={() => onSetPick('ball_2l_odd', 'ball_2_odd_even', 'odd')}
                >
                  <span className='tx'>2번볼 (노란색) 홀</span>
                  <span className='per'>{gameStore.data.dist.ball_2_odd_percent}%</span>
                </button>
                <button
                  type='button'
                  className={clsx('OVER', pickClass === 'ball_2_even' && 'selected')}
                  onClick={() => onSetPick('ball_2_even', 'ball_2_odd_even', 'even')}
                >
                  <span className='tx'>2번볼 (노란색) 짝</span>
                  <span className='per'>{gameStore.data.dist.ball_2_even_percent}%</span>
                </button>
              </div>
            </div>
            {/* // pick_select */}

            {/* pick_message */}
            <div className='pick_message'>
              <h3 className='tit'>픽 메시지</h3>
              <div className='message_type'>
                <CreatableSelect
                  placeholder={commentPlaceholder}
                  menuPlacement='top'
                  value={commentIndex}
                  isClearable={true}
                  onChange={(e) => {
                    onSetPickComment(e)
                  }}
                  onBlur={(e) => {
                    if (e.target?.value) {
                      onSetPickComment({
                        __isNew__: true,
                        value: e.target.value,
                        label: e.target.value,
                      })
                    }
                  }}
                  options={commentDefaultData}
                />
              </div>
              <button type='submit' className='btn_submit' onClick={() => insertPickComment()}>
                픽등록하기
              </button>
            </div>
            {/* // pick_message */}
          </div>
          {/* // pick_register_wrap */}
        </>
      )}
    </div>
  )
})

export { DoubleDragonPick }
